export const VENDOR_OPPORTUNITY_STATUS = {
	"INVITATION MAIL SENT": 7,
	"ACCEPTED TERMS & CONDITIONS": 8,
	"ACCEPTED TO PARTICIPATE IN EVENT": 9,
	"BID PLACED": 10,
	"RESPONSE RETRACTED": 11,
	"BID PLACED ON BEHALF OF": 12,
	"RETRACTED ON BEHALF OF": 13,
	"RESPONSE DRAFT": 14,
	"DECLINED INVITATION": 17
  };

export const RFP_CONTRIBUTOR_ROLE_KEY = 'partner:rfp:contributor'

export const USER_ROLE_IDS = {
	MEMBER: '40b61568-4b0c-11ec-a04e-c1630e4615a6',
	CHANNEL: '140e718e-c16d-4f1d-ad62-15216aeda4a8',
	PARTNER: '40c16ee0-4b0c-11ec-a04e-c1630e4615a6',
	CONTRIBUTOR: '4ec156ea-f65d-4657-a31c-132a010d7141'
}
